export default __webpack_public_path__ + "static/media/home-bg.95b63de2.jpg";